var map = {
	"./1.1.png": 7665,
	"./1.2.png": 7847,
	"./10.mpeg": 6454,
	"./2.png": 367,
	"./3.1.png": 8344,
	"./3.2.png": 620,
	"./4.1.png": 4707,
	"./4.2.png": 7425,
	"./5.png": 1842,
	"./6.png": 8072,
	"./7.mpeg": 7271,
	"./8.png": 6913,
	"./9.png": 2346
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5158;